import { RefObject, useCallback, useImperativeHandle, useState } from "react";

import { IconButton, Modal, Tooltip } from "@mui/material";
import { IoClose } from "react-icons/io5";
import {
	ReactZoomPanPinchRef,
	TransformComponent,
	TransformWrapper,
} from "react-zoom-pan-pinch";

import "./image_viewer.scss";

export type TImageViewerProps = {
	ref: RefObject<TImageViewerRef | null>;
};
export type TImageViewerRef = {
	open: ({ url }: { url: string }) => void;
	close: () => void;
};

export function ImageViewer(props: TImageViewerProps) {
	const [isOpen, setIsOpen] = useState(false);
	const [scale, setScale] = useState(1);
	const [url, setUrl] = useState("");

	const open = useCallback(({ url: imageUrl }: { url: string }) => {
		setUrl(imageUrl);
		setIsOpen(true);
	}, []);

	const close = () => {
		setIsOpen(false);
	};

	useImperativeHandle(props.ref, () => ({ open, close }), [open]);

	const onClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
		if (reason === "escapeKeyDown") {
			close();
		}
	};

	const onZoomStop = (ref: ReactZoomPanPinchRef) => {
		setScale(Math.round(ref.state.scale));
	};

	const renderMedia = () => {
		if (!url) {
			return null;
		}

		return (
			<TransformWrapper
				minScale={1}
				maxScale={5}
				onZoomStop={onZoomStop}
				smooth={false}
				doubleClick={{ step: 2, mode: scale === 5 ? "reset" : "zoomIn" }}
				key={url}>
				<TransformComponent
					wrapperClass="transform-wrapper"
					contentClass="image-container">
					<img src={url} className="image" alt={url} />
				</TransformComponent>
			</TransformWrapper>
		);
	};

	return (
		<Modal open={isOpen} onClose={onClose}>
			<div className="view-media-modal-container">
				<Tooltip title="Close">
					<IconButton className="close-button" onClick={close}>
						<IoClose />
					</IconButton>
				</Tooltip>
				{renderMedia()}
			</div>
		</Modal>
	);
}
